import { postFacturaOcr } from "api/Factura.service"
import { useUsuarioEmpresas } from "api/Usuario.hook"
import { mapFacturaOcr } from "common/mappers/mapDocumentoToPost"
import ContactosService from "common/services/ContactosService"
import notification from "common/utils/notification"
import i18next from "i18next"
import { useState } from "react"
import { useHistory } from "react-router-dom"
import { IMPORTAR_FACTURAS_OCR } from "routes/RoutePaths"

async function insertFactura(data: $TSMigrationFixMe) {
  const mappedData = mapFacturaOcr(data)
  await postFacturaOcr(mappedData)

  notification.success({
    body: `${i18next.t("notification.invoceCorrectImported")}`,
  })
}

async function insertContactoIfNotExists(
  contacto: $TSMigrationFixMe,
  EmpresaCreacionId: $TSMigrationFixMe
) {
  const { data: contactoExists } = await ContactosService.getByContactoNif(
    contacto.nif,
    EmpresaCreacionId
  )

  if (contactoExists) {
    return contactoExists.empresaContactoId
  }

  const { data } = await ContactosService.post({
    empresaCreacionId: EmpresaCreacionId,
    ...contacto,
  })

  return data.empresaContactoId
}

const getId = (empresas = [], nifuser = "") => {
  // @ts-expect-error TS(2339): Property 'id' does not exist on type 'undefined'.
  const { id } = empresas.find(({ nif }) => nif === nifuser)
  return id
}

const useImportarFacturaOcr = () => {
  const [importandoFactura, setImportandoFactura] = useState(false)
  const {
    usuarioEmpresas: { items: empresas },
  } = useUsuarioEmpresas()
  const history = useHistory()

  const handlePostFactura = async (data: $TSMigrationFixMe) => {
    setImportandoFactura(true)
    const onSucces = async (data: $TSMigrationFixMe) => {
      await insertFactura(data)
      history.push(IMPORTAR_FACTURAS_OCR)
    }

    try {
      if (
        data.empresaCreacion?.is === "librador" &&
        data.empresaCreacion?.nif === data.librador.nif &&
        data.empresaCreacion?.verificada
      ) {
        const clienteId = await insertContactoIfNotExists(
          data.librado,
          data.empresaCreacionId
        )
        data.libradoId = clienteId
        // @ts-expect-error TS(2345): Argument of type 'GetAllEmpresasUsuarioDtoProps[] ...
        data.libradorId = getId(empresas, data.librador.nif)
        await onSucces(data)
      } else if (
        data.empresaCreacion?.is === "librado" &&
        data.empresaCreacion?.nif === data.librado.nif
      ) {
        const proveedorId = await insertContactoIfNotExists(
          data.librador,
          data.empresaCreacionId
        )
        data.libradorId = proveedorId
        // @ts-expect-error TS(2345): Argument of type 'GetAllEmpresasUsuarioDtoProps[] ...
        data.libradoId = getId(empresas, data.librado.nif)
        await onSucces(data)
      }
      setImportandoFactura(false)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
      setImportandoFactura(false)
    }
  }

  return {
    importandoFactura,
    handlePostFactura,
  }
}

export default useImportarFacturaOcr
